import {Directive, TemplateRef} from "@angular/core";

@Directive({
  selector: '[intTableColumnsLimiterItem]'
})
export class IntTableColumnsLimiterItemDirective {
  constructor(
    readonly templateRef: TemplateRef<any>
  ) {
  }
}
